export const INSPECTION_KIND_FIELD_LABELS = {
  code: '種類代碼',
  name: '名稱',
  status: '狀態',
  items: '條件',
};
